<template>
    <card-tile full-width :title="title" :min-height="270">
        <template v-slot:toolbar-actions>
            <add-student-menu
                v-if="Object.keys(session).length > 0"
                :instructor="instructor"
                @add-students="$emit('add-students', $event)"
            ></add-student-menu>
        </template>

        <div class="px-4 py-4 text-center" v-if="students.length === 0">
            <h3 class="grey--text text--darken-2 mb-4">
                You haven't invited any students yet.
                <span v-if="sessions.length === 0"
                    >You will need to add sessions to invite students.</span
                >
            </h3>
            <add-student-menu
                v-if="Object.keys(session).length > 0"
                large
                :instructor="instructor"
                @add-students="$emit('add-students', $event)"
            ></add-student-menu>
        </div>
        <student-list
            v-if="students.length > 0"
            :instructor="instructor"
            :students="students"
            :session="session"
            :key="$_.get(session, 'id', $uuid.v4())"
        ></student-list>
    </card-tile>
</template>

<script>
export default {
    name: "students-card",
    components: {
        CardTile: () =>
            import("@/components/program/components/Dashboard/CardTile.vue"),
        StudentList: () =>
            import("@/components/program/components/StudentList.vue"),
        AddStudentMenu: () =>
            import(
                "@components/program/components/ProgramInstructor/AddStudentMenu.vue"
            ),
    },
    props: {
        sessions: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
        session: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
        students: {
            type: Array,
            required: true,
        },
        instructor: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            addDialog: false,
        };
    },
    computed: {
        title() {
            return Object.keys(this.session).length
                ? `Students - ${this.session.name}`
                : "Students";
        },
    },
    methods: {},
};
</script>

